import React, { useEffect, useState } from 'react';
import TripForm from '../components/TripForm';
import TripList from '../components/TripList';
import useTrips from '../hooks/useTrips';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';

const TripsPage = ({ user }) => {
  // If no role, render nothing
  if (!user?.role) return null;

  const { trips, addTrip, editTrip, removeTrip, editingTrip, setEditingTrip, genericSavedMsg, refreshTrips } = useTrips();
  const [vehicles, setVehicles] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    fetchWithAuth(`${BACKEND_URL}/vehicles`)
      .then(res => res.json())
      .then(data => setVehicles(data));
    fetchWithAuth(`${BACKEND_URL}/drivers`)
      .then(res => res.json())
      .then(data => setDrivers(data));
    fetchWithAuth(`${BACKEND_URL}/assignments`)
      .then(res => res.json())
      .then(data => setAssignments(data));
  }, []);

  // The form should always be visible, even for drivers
  return (
    <div className="space-y-6">
      {genericSavedMsg && (
        <div className="bg-green-100 text-green-800 px-4 py-2 rounded">
          {genericSavedMsg}
        </div>
      )}
      <TripForm
        onSave={editingTrip ? async (data) => {
          const result = await editTrip(data);
          // Refresh vehicles after editing a trip
          fetchWithAuth(`${BACKEND_URL}/vehicles`)
            .then(res => res.json())
            .then(data => setVehicles(data));
          return result;
        } : async (data) => {
          const result = await addTrip(data);
          // Refresh vehicles after adding a trip
          fetchWithAuth(`${BACKEND_URL}/vehicles`)
            .then(res => res.json())
            .then(data => setVehicles(data));
          return result;
        }}
        editingTrip={editingTrip}
        vehicles={vehicles}
        drivers={drivers}
        assignments={assignments}
        onCancelEdit={() => setEditingTrip(null)}
      />
      <TripList
        trips={trips}
        vehicles={vehicles}
        drivers={drivers}
        onEdit={setEditingTrip}
        onRemove={user.role === "Conductor" || user.role === "conductor" ? undefined : removeTrip}
        refresh={refreshTrips}
        isConductor={user.role === "Conductor" || user.role === "conductor"}
      />
    </div>
  );
};

export default TripsPage;